import { useSelector } from '@lingoda/hooks';
import { countyCodeSelector } from '@lingoda/auth';
import {
    type ApolloError,
    Currency,
    getApolloErrorUiMessage,
    useStudentCurrenciesQuery,
} from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';

type UsePaymentCurrenciesResult = {
    defaultCurrency: Currency;
    currencies: Currency[];
    loading: boolean;
    error?: ApolloError;
};

export const usePaymentCurrencies = (): UsePaymentCurrenciesResult => {
    const countryCode = useSelector(countyCodeSelector);

    const { data, loading, error } = useStudentCurrenciesQuery({
        fetchPolicy: 'cache-and-network',
        variables: countryCode ? { countryCode } : undefined,
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    const currencies = (data?.clusterCurrencies.currencies ?? []) as Currency[];
    const defaultCurrency = (data?.clusterCurrencies.defaultCurrency as Currency) ?? Currency.Eur;

    return { defaultCurrency, currencies, loading, error };
};
